import '../scss/organisms/_cmp-carousel.scss'
import CarouselSplide from './components/CarouselSplide/CarouselSplide'
const carousels = [...document.querySelectorAll('.carousel__splide')]
carousels.map(carousel => new CarouselSplide(carousel))